const AUTH_TOKEN_KEY = 'auth-token'

export default defineNuxtRouteMiddleware((to) => {
  // Skip authentication check for login page
  if (to.path === '/login') {
    return
  }

  // Skip authentication check for API routes (avoid redirect loops)
  if (to.path.startsWith('/api/')) {
    return
  }

  // Check for auth token in cookie
  const token = useCookie<string | null>(AUTH_TOKEN_KEY)

  if (!token.value) {
    return navigateTo('/login')
  }
})
